module.exports = __webpack_public_path__ + "mainassets/img/graf3.524cb1e7.svg";